import { render, staticRenderFns } from "./SettingsExternalCompanyView.vue?vue&type=template&id=d715b43c&scoped=true&"
import script from "./SettingsExternalCompanyView.vue?vue&type=script&lang=js&"
export * from "./SettingsExternalCompanyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d715b43c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d715b43c')) {
      api.createRecord('d715b43c', component.options)
    } else {
      api.reload('d715b43c', component.options)
    }
    module.hot.accept("./SettingsExternalCompanyView.vue?vue&type=template&id=d715b43c&scoped=true&", function () {
      api.rerender('d715b43c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SettingsExternalCompanyView.vue"
export default component.exports